"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageValidationMessage = void 0;
var React = require("react");
var services_1 = require("@falcon/services");
function PageValidationMessage(props) {
    return (React.createElement("div", { className: "page-validation journey-validation-summary validation-error-top", role: "alert" },
        React.createElement("div", { className: "page-validation-alert" },
            React.createElement("img", { className: "page-validation-alert-icon", alt: "Alert icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/alert-red.svg") })),
        React.createElement("div", { className: "page-validation-message" },
            React.createElement("p", { className: "page-validation-message-top" }, props.topText),
            React.createElement("p", { className: "page-validation-message-bottom" }, props.bottomText)),
        React.createElement("div", { className: "page-validation-close" },
            React.createElement("button", { type: "button", className: "btn page-validation-close-button", "aria-label": "close alert", onClick: props.handleCloseFunction }))));
}
exports.PageValidationMessage = PageValidationMessage;
//# sourceMappingURL=PageValidationMessage.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/helpers/PageValidationMessage.js
// module id = 377
// module chunks = 0